import { createEnumMapper } from '../util/create-enum-mapper';

export interface ClientAccount {
  name: string;
  account_id: string;
}

export interface AdminServiceRole {
  name: DefaultRoles;
  user: string | ClientUser;
}

export interface AdminAccountService {
  service_id: string;
  roles: Array<AdminServiceRole>;
}

export interface AdminAccount extends ClientAccount {
  services: Array<AdminAccountService>;
  isDemoAccount: boolean;
}

export interface UserServiceRole {
  service_id: string;
  service: ClientService;
  name: DefaultRoles;
}

export interface ClientUser {
  user_id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
}

export interface UserAccount {
  account: ClientAccount;
  roles: UserServiceRole[];
}

export interface ClientBanzaiRole {
  name: string;
  service_id: string;
}

export interface CreateAccount {
  name: string;
}

export interface MeUser extends ClientUser {
  accounts: Array<UserAccount>;
  banzaiRoles: Array<ClientBanzaiRole>;
}

export enum DefaultRoles {
  Owner = 'owner',
  Admin = 'admin',
  User = 'user',
}

export const defaultRolesMapper = createEnumMapper(DefaultRoles, {
  Admin: 'Administrator',
  Owner: 'Owner',
  User: 'User',
});

export interface UserSettingsUser {
  user_id?: string;
  fullName?: string;
  email: string;
  role: DefaultRoles | 'pending';
  invitation_id?: string;
}

export interface CreateUserInvitation {
  email: string;
}

export interface ClientUserInvitation extends CreateUserInvitation {
  invitation_id: string;
  account_id: string;
  service_id: string;
  sent_by_id: string;
}

export interface FullUserInvitation extends ClientUserInvitation {
  sent_by: ClientUser;
  account: ClientAccount;
}

export interface ClientEmailVerification {
  verification_id: string;
}

export interface ServerEmailVerification extends ClientEmailVerification {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  salt: string;
  service_id: string;
  otp: string;
}

export interface FullEmailVerification extends ServerEmailVerification {}

export interface ClientPasswordReset {}

export interface ServerPasswordReset extends ClientPasswordReset {
  reset_id: string;
  user: ClientUser;
  service_id: string;
}

export interface RegisterUser {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  service_id: string;
}

export interface ClientService {
  service_id: string;
  name: string;
  url: string;
}

export interface UserWithAccounts {
  user_id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  accounts: Array<{ account_id: string; name: string }>;
}
